import { DependenciesInjection } from "app/di/DependencyInjection";
import { AppStartUpImpl } from "../data/AppStartUpImpl";
import { IAppStartUpRepository } from "../domain/repositories/IAppStartUpRepository";
import { AppStartUpUseCase } from "../domain/useCases/AppStartUpUseCase";
import { AppStartUpToken } from "./AppStartUpToken";

export class AppStartUpInjection {
  static initInjections() {
    DependenciesInjection.register<IAppStartUpRepository>(
      AppStartUpToken.IAppStartUpRepository,
      AppStartUpImpl,
      "otherRepo",
    );
    DependenciesInjection.register<AppStartUpUseCase>(
      AppStartUpToken.AppStartUpUseCase,
      AppStartUpUseCase,
      "otherRepo",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IAppStartUpRepository>(
      AppStartUpToken.IAppStartUpRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<AppStartUpUseCase>(
      AppStartUpToken.AppStartUpUseCase,
    );
  }
}
